import { api } from "../utils/AuthManager";
const PatchGroup = async (id, data) => {
  return api
    .patch(`/api/group/${id}/`, data)

    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default PatchGroup;
